import { KHS_SMALL_ARCHITECTURE_PRESET_DATA } from './khs-small-architecture.catalog.generated';

export type YsDecorationCategory =
    | '경복궁'
    | '덕수궁'
    | '창경궁'
    | '창덕궁'
    | '창덕궁 연경당'
    | '창덕궁 구선원전'
    | '창덕궁 궐내각사';

export interface YsDecorationPreset {
    id: string;
    name: string;
    category: YsDecorationCategory;
    icon: string;
    url: string;
    performanceUrl?: string;
    collisionUrl: string;
    targetHeight: number;
}

// Only models placed as native YS scenery in the palace map are enabled here.
// Custom FBX placements intentionally keep their original browser-stored model
// so their existing normalization, pivot and placement remain unchanged.
const YS_POSITION_SAFE_PERFORMANCE_DECORATION_IDS = new Set([
    'geunjeongjeon',
    'khs-changdeokgung-001',
    'khs-changdeokgung-005',
    'khs-changdeokgung-006',
    'khs-changdeokgung-013',
    'khs-changdeokgung-015',
    'khs-gyeongbokgung-002',
    'khs-gyeongbokgung-004',
    'khs-gyeongbokgung-005',
    'khs-gyeongbokgung-010',
    'khs-gyeongbokgung-016',
    'khs-gyeongbokgung-019',
    'khs-gyeongbokgung-020',
    'khs-gyeongbokgung-021',
    'khs-gyeongbokgung-027',
    'khs-gyeongbokgung-031',
    'khs-gyeongbokgung-032',
    'khs-gyeongbokgung-038',
    'khs-gyeongbokgung-040',
    'khs-gyeongbokgung-044',
    'yeonkyung-fence',
    'yeonkyung-sooinmun'
]);

const asset = (
    id: string,
    name: string,
    category: YsDecorationCategory,
    targetHeight: number,
    icon: string = '🏯'
): YsDecorationPreset => ({
    id,
    name,
    category,
    icon,
    url: `/assets/quiz-runner/decorations/ys/${id}.glb?v=20260826-quality4`,
    performanceUrl: YS_POSITION_SAFE_PERFORMANCE_DECORATION_IDS.has(id)
        ? `/assets/quiz-runner/decorations/ys/performance/${id}.glb?v=20260901-position-safe1`
        : undefined,
    collisionUrl: `/assets/quiz-runner/decorations/ys/collision/${id}.json?v=20260826-surface1`,
    targetHeight
});

export const YS_DECORATION_CATEGORIES: YsDecorationCategory[] = [
    '경복궁',
    '덕수궁',
    '창경궁',
    '창덕궁',
    '창덕궁 연경당',
    '창덕궁 구선원전',
    '창덕궁 궐내각사'
];

export const YS_DECORATION_PRESETS: YsDecorationPreset[] = [
    asset('gyeonghoeru', '경복궁 경회루', '경복궁', 14, '🏛️'),
    asset('geunjeongjeon', '경복궁 근정전', '경복궁', 18, '🏯'),
    asset('yeonkyung-south-haenggak', '연경당 남측 내행각', '창덕궁 연경당', 7),
    asset('yeonkyung-fence', '연경당 담장', '창덕궁 연경당', 2.5, '🧱'),
    asset('yeonkyung-stable', '연경당 마구간', '창덕궁 연경당', 5, '🐎'),
    asset('yeonkyung-sarangchae', '연경당 사랑채', '창덕궁 연경당', 8),
    asset('yeonkyung-west-haenggak', '연경당 서측 내행각', '창덕궁 연경당', 7),
    asset('yeonkyung-sooinmun', '연경당 수인문', '창덕궁 연경당', 5, '🚪'),
    asset('yeonkyung-anchae', '연경당 안채', '창덕궁 연경당', 9),
    asset('yeonkyung-outer-haenggak', '연경당 외행각', '창덕궁 연경당', 7),
    asset('yeonkyung-jangrakmun', '연경당 장락문', '창덕궁 연경당', 5, '🚪'),
    asset('yeonkyung-jangyangmun', '연경당 장양문', '창덕궁 연경당', 5, '🚪'),
    asset('old-shrine-south-haenggak', '구선원전 남행각·억석루', '창덕궁 구선원전', 9),
    asset('old-shrine-naejaesil', '구선원전 내재실', '창덕궁 구선원전', 8),
    asset('old-shrine-naechaldang', '구선원전 내칠당', '창덕궁 구선원전', 8),
    asset('old-shrine-bukjinseolcheong', '구선원전 북진설청', '창덕궁 구선원전', 7),
    asset('old-shrine-seojinseolcheong', '구선원전 서진설청', '창덕궁 구선원전', 7),
    asset('old-shrine-yangjidang', '구선원전 양지당', '창덕궁 구선원전', 9),
    asset('old-shrine-yangjidang-haenggak', '구선원전 양지당 행각', '창덕궁 구선원전', 7),
    asset('old-shrine-uipunggak', '구선원전 의풍각', '창덕궁 구선원전', 8),
    asset('gwollaegaksa-geomseocheong', '궐내각사 검서청', '창덕궁 궐내각사', 7),
    asset('gwollaegaksa-geomseocheong-annex', '궐내각사 검서청 부속채', '창덕궁 궐내각사', 6),
    ...KHS_SMALL_ARCHITECTURE_PRESET_DATA.map(
        ([id, name, category, targetHeight, icon]) => asset(id, name, category, targetHeight, icon)
    )
];
